// extracted by mini-css-extract-plugin
export default {"search_box":"SearchInput_search_box__sQamX","search_icon":"SearchInput_search_icon__TCMFX","mobile_search":"SearchInput_mobile_search__yynzM"};